// Namespace.
export const STORE_NAME = 'StaffManagementStoreV2';

// Published action types handled by store.
export const EVENT_NAMES = {
  DATA: `${STORE_NAME}/data`,
  MERGE: `${STORE_NAME}/merge`,
  NOTIFICATIONS: `${STORE_NAME}/notifications`,
  PARTNER_ROLE_TEMPLATES: `${STORE_NAME}/partnerRoleTemplates`,
  RESET: `${STORE_NAME}/reset`,
  SET: `${STORE_NAME}/set`,
  UI: `${STORE_NAME}/ui`,
  UPDATE: `${STORE_NAME}/update`,
};
// This array functions to hide roles still under development from the UI
export const getRolesToOmit = () => {
  return [''];
};
